<template>
  <template v-if="text?.length">
    <div class="relative flex justify-center">
      <span class="bg-white px-4 text-sm">
        {{ text }}
      </span>
      <div class="strikethrough-message" />
    </div>
  </template>
  <template v-else>
    <hr>
  </template>
</template>

<script>
export default {
  name: 'HorizontalLine',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@sass/design-system/variables" as ds-variables;

.strikethrough-message {
  width: 100%;
  height: 1px;
  position: absolute;
  background: ds-variables.$grey-300;
  top: 50%;
  z-index: -1;
}
</style>
